import get from "lodash/get"
import { makeStyles } from "tss-react/mui"
import Box from "component-lib/Base/components/Box"
import { FormattedTextField } from "component-lib/Base/components/FormattedTextField/FormattedTextField"
import { handleEnterPress } from "utils-lib/handleEnterPress"
import { withLocalization } from "hoc-lib/localization"
import getContentUrl from "utils-lib/getContentUrl"
import { ReactSVG } from "react-svg"
import getLanguageRoute from "utils-lib/getLanguageRoute"
import { getWindow } from "utils-lib/getWindow"
import Copyright from "./Copyright/Copyright"
import LegalLinks from "./LegalLinks/LegalLinks"
import "./FooterLegal.scss"

const strings = {
  en_CA: {
    PREFERENCES_TEXT: `Your Privacy Choices`,
    CALIFORNIA_NOTICE: `California Privacy Notice`,
  },
  fr_CA: {
    PREFERENCES_TEXT: `Vos choix en matière de confidentialité`,
    CALIFORNIA_NOTICE: `Politique de confidentialité pour la Californie`,
  },
}

const useStyles = makeStyles()((theme, { alignment, isResiOrComm }) => ({
  rte: {
    textAlign: alignment,
    [theme.breakpoints.up(`lg`)]: {
      paddingTop: "1rem",
    },
    [theme.breakpoints.down(`sm`)]: {
      paddingTop: "1rem",
    },
    "& p": {
      color: theme.palette.common.white,
      fontSize: "12px",
      fontFamily: "Maax-regular",
      marginBottom: `0`,
      lineHeight: `1rem`,
      "& a": {
        color: theme.palette.common.white,
      },
      "& ul": {
        marginLeft: `1rem`,
        textAlign: `left`,
        "& li": {
          listStyle: `disc`,
        },
      },
      "& ol": {
        paddingLeft: `1rem`,
        textAlign: `left`,
        "& li": {
          listStyle: `number`,
        },
      },
    },
  },
  svg: {
    "& svg": {
      width: `2rem`,
    },
  },
  footerCA: {
    paddingBottom: isResiOrComm ? `92px !important` : ``,
  },
}))

const ssrWindow = getWindow()

const FooterLegal = ({
  copyright,
  isMobileNav = false,
  legalLinks,
  siteLanguage,
  strings,
  footernote = ``,
  alignment = ``,
}) => {
  const language = get(siteLanguage, `language`, `en_US`)
  const languageRoute = getLanguageRoute(language)
  const routeResi = `${ssrWindow.location.origin}${languageRoute}/home/residential-waste-recycling-pickup/residential-services`
  const routeComm = `${ssrWindow.location.origin}${languageRoute}/business/business-waste-recycling-pickup/permanent-dumpster-sizes`

  // Determine the className based on the route
  const isResiOrComm =
    ssrWindow.location.href.indexOf(routeResi) === 0 ||
    ssrWindow.location.href.indexOf(routeComm) === 0
  const { classes } = useStyles({ alignment, isResiOrComm })

  // Privacy notice will be displayed in english irrespective of the language selection.
  const privacyNoticeUrl = `${ssrWindow.location.origin}/us/en/privacy/california-notice`

  return (
    <div
      data-testid="FooterLegal"
      className={`FooterLegal FooterLegal--${get(
        siteLanguage,
        `language`,
        ``,
      )} wm-footer-green
      ${classes.footerCA}`}
    >
      <div className="container">
        <div className="FooterLegal__container d-xl-flex justify-content-between align-items-center">
          <div className="d-xl-flex w-100 justify-content-between maax-font-weight-regular">
            <Copyright copyrightMessaging={copyright} />
            <div className="d-xl-flex justify-content-between">
              <LegalLinks links={legalLinks} isMobileNav={isMobileNav} />
            </div>
          </div>
        </div>
        <div className="pt-3 d-flex">
          <ReactSVG
            wrapper="span"
            className={`pt-1 px-2 align-text-top ${classes.svg}`}
            src={getContentUrl(
              "/content/dam/wm/icons/controls/privacyoptions.svg",
            )}
          />
          <a
            className="pt-2 pt-sm-0 ot-sdk-show-settings ot-floating-button text-white text-decoration-none d-inline-flex wm-cursor-pointer"
            style={{
              fontSize: `14px`,
            }}
            onClick={() => {
              ssrWindow.OneTrust?.ToggleInfoDisplay()
            }}
            role="link"
            tabIndex={0}
            onKeyPress={(e) =>
              handleEnterPress(e, () => {
                ssrWindow.OneTrust?.ToggleInfoDisplay()
              })
            }
          >
            {strings.PREFERENCES_TEXT}
          </a>
        </div>
        {footernote && (
          <Box className={`${classes.rte}`}>
            <a
              className="californiaText text-white text-decoration-none d-inline-flex wm-cursor-pointer pb-3"
              href={privacyNoticeUrl}
              style={{
                fontSize: `14px`,
              }}
            >
              {strings.CALIFORNIA_NOTICE}
            </a>
            <FormattedTextField variant="body1" component="span">
              {footernote}
            </FormattedTextField>
          </Box>
        )}
      </div>
    </div>
  )
}

// // Note: React 19 no-longer supports propTypes. Leaving this for reference.
// FooterLegalLegacy.propTypes = {
//   copyright: PropTypes.string.isRequired,
//   isMobileNav: PropTypes.bool,
//   legalLinks: PropTypes.array.isRequired,
//   siteLanguage: PropTypes.object.isRequired,
//   strings: PropTypes.object.isRequired,
//   footernote: PropTypes.string,
//   alignment: PropTypes.string,
// }

// // Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// FooterLegalLegacy.defaultProps = {
//   isMobileNav: false,
//   footernote: ``,
//   alignment: ``,
// }

export default withLocalization(strings)(FooterLegal)
